
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carbon-for-campus",
      function () {
        return require("private-next-pages/carbon-for-campus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carbon-for-campus"])
      });
    }
  